export const SET_CUSTOMER_CERTIFICATE = "@AUDIENCE/SET_CUSTOMER_CERTIFICATE";